import { SVGAttributes } from 'react'

const LoadingSpinner = ({ className, color = '#ffffff', ...props }: SVGAttributes<SVGElement>) => {
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`animate-spin ${className}`}
    >
      <circle cx="8" cy="8" r="6" stroke={color} strokeWidth="2" strokeOpacity="0.3" />
      <path d="M14 8a6 6 0 0 1-6 6" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}

export default LoadingSpinner
